import * as types from '../const/action.types';

export function display(state = {}, action) {
    switch (action.type) {
        case types.LOAD_DISPLAY_SUCCESS:
            console.log(action.data);
            return action.data;
        default:
            return state;
    }
}

export function displays(state = [], action) {
    switch (action.type) {
        case types.DISPLAYS_SUCCESS:
            return action.data;
        default:
            return state;
    }
}

export function displaysHasErrored(state = { hasErrored: false, error: '' }, action) {
    switch (action.type) {
        case types.DISPLAYS_HAS_ERROR:
            return {
                hasErrored: action.hasErrored,
                error: action.error,
            };

        default:
            return state;
    }
}

export function displaysIsLoading(state = false, action) {
    switch (action.type) {
        case types.DISPLAYS_IS_LOADING:
            return action.isLoading;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/display.reducer.js